import {useTranslation} from 'react-i18next';
import {useRegistrationStep} from 'components/RegistrationProgress';

export {
  getIVCaptureCopy,
  getIVCaptureChecks,
  showsCodeSide,
  useIVCaptureScreenText,
  useLivenessStageText,
} from '@chekin/shared/guest-form';
export type {IVCaptureCopy, IVCaptureStep} from '@chekin/shared/guest-form';

export function useIVCaptureKicker(kicker: string, suffix?: string) {
  const {t} = useTranslation();
  const stepState = useRegistrationStep();

  const parts = [
    kicker,
    stepState && t('step_of_steps', {step: stepState.step, steps: stepState.totalSteps}),
    suffix,
  ];

  return parts.filter(Boolean).join(' · ');
}
